import projection from '../generated/pwj5n5f1.json';
import { AcceptanceManifest } from '../types';
export const pwj5n5f1AcceptanceManifest = projection as AcceptanceManifest;
